import { TreeNode } from './types';

export function flattenTree(tree: TreeNode[]): TreeNode[] {
  const result: TreeNode[] = [];

  function traverse(nodes: TreeNode[]): void {
    nodes.forEach((node) => {
      result.push(node);
      if (node.type === 'section' && node.children.length > 0) {
        traverse(node.children);
      }
    });
  }

  traverse(tree);
  return result;
}

export function findNodeById(tree: TreeNode[], id: string): TreeNode | null {
  for (const node of tree) {
    if (node.id === id) {
      return node;
    }
    if (node.type === 'section' && node.children.length > 0) {
      const found = findNodeById(node.children, id);
      if (found) {
        return found;
      }
    }
  }
  return null;
}

export function getNodePath(tree: TreeNode[], id: string): string[] {
  function traverse(nodes: TreeNode[], path: string[]): string[] | null {
    for (const node of nodes) {
      const currentPath = [...path, node.id];
      if (node.id === id) {
        return currentPath;
      }
      if (node.type === 'section' && node.children.length > 0) {
        const found = traverse(node.children, currentPath);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  return traverse(tree, []) || [];
}
